
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { updateFullScreenLoader } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { http } from "../../helpers/http";
import { patterns, useForm } from "../../helpers/useForm";
import Form from "react-bootstrap/Form";
import { replaceValue, allowNumbersWithNoSpaces } from "../../helpers/help";


function AddCardModal(props) {
  const { showCardModal, setShowCModalard, setAccountToken, accountToken } = props;
  const dispatch = useDispatch();
  const viewCartData = useSelector((state) => state.cart?.viewCartData);
  const [expiryDate, setExpiryDate] = useState("");
  const [expMonth, setExpMonth] = useState("");
  const [expYear, setExpYear] = useState("")
  const [cardNumber, setCardNumber] = useState("");
  const [cardName, setCardName] = useState("");
  const [cvv, setCvv] = useState("");
  const [zipcode, setZipcode] = useState("")
  const [errors, setErrors] = useState({});

  const isValidCard = () => {
    let isValid = true;
    /*Required Field */
    if (!cardName) {
      errors.cardName = true;
      isValid = false;

    }

    /*Required Field */
    if (!cardNumber) {
      errors.cardNumber = true;
      isValid = false;

    }
    if (cardNumber.length < 16) {
      errors.invalid_card_number = true;
      isValid = false;

    }
    /*Required Field */
    if (!expiryDate) {
      errors.expiryDate = true;
      isValid = false;

    }
    /*Required Field */
    if (!cvv) {
      errors.cvv = true;
      isValid = false;

    }
    if (!zipcode) {
      errors.zipcode = true;
      isValid = false;

    }

    setErrors({ ...errors });
    return isValid;
  };

  const formatAndSetCcNumber = (e) => {

    if (e.key === 'e' || e.key === '-' || e.key === '+') {
      e.preventDefault();
    }

    const inputVal = e.target.value.replace(/ /g, "");
    errors.cardNumber = false;
    let inputNumbersOnly = inputVal.replace(/\D/g, "");

    if (inputNumbersOnly.length > 16) {
      inputNumbersOnly = inputNumbersOnly.substr(0, 16);
    }
    if (inputNumbersOnly.length === 16) {
      errors.invalid_card_number = false;
    }

    const splits = inputNumbersOnly.match(/.{1,4}/g);

    setCardNumber(inputNumbersOnly);
  };

  const handleCardNumberKeyDown = (e) => {
    if (e.key === 'e' || e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };

  const addCard = () => {
    http(
      {
        method: "POST",
        url: "addCard",
        isSecure: true,
        body: {
          card_number: Number(cardNumber),
          expiration_month: expMonth,
          expiration_year: expYear,
          card_type: 1,
          cvv: cvv,
          zip_code: zipcode,
          type: "Take Out",
          outletId: viewCartData?.dishes?.outletDetails?.outletId,
        }
      },
      (res) => {
        if (res.error !== "true") {
          setShowCModalard(false);
          toast.success(res.errorMessage);
          dispatch(updateFullScreenLoader(false));
        }
        if (res.error === "true") {
          toast.error(res.errorMessage);
          dispatch(updateFullScreenLoader(false));
        }
      }
    )

  }

  const cardSubmit = (event) => {
    event.preventDefault();
    if (!isValidCard()) return;
    setCardNumber("")
    setCardName("")
    setCvv("")
    setZipcode("")
    setExpiryDate("")
    setErrors({})
    addCard();
  }

  useEffect(() => {
    let value = expiryDate.split("/");
    setExpMonth(value[0]);
    setExpYear(value[1]);
  }, [expiryDate]);
  return (
    <Modal
      show={showCardModal}
      onHide={() => setShowCModalard(false)}
      centered
      className="center-close-icon"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton></Modal.Header>
      <form onSubmit={cardSubmit}>
        <div className="bodyModal">
          <h4 className="head4 text-center mb-0 pb-0">
            Add Card
          </h4>
          <div className="mt-5">
            <div className="row">
              <div className="col-12 mb-4">
                <div className="input-grbox">
                  <label className="blackC">
                    Card Holder Name<sup>*</sup>
                  </label>
                  <input type="text"
                    className="fillinput"
                    placeholder="Enter name"
                    value={cardName}
                    onChange={(e) => {
                      const re = /^[a-zA-Z ]*$/;
                      errors.cardName = false;
                      if (e.target.value.match(re)) {
                        setCardName(e.target.value);

                      }
                    }}
                  />
                </div>
                {errors.cardName === true && (
                  <span className="text-danger fz14">
                    Required
                  </span>
                )}
              </div>
              <div className="col-12 mb-4">
                <div className="input-grbox">
                  <label className="blackC">
                    Card Number<sup>*</sup>
                  </label>
                  <input
                    type="number"
                    name="cardNumber"
                    className="fillinput"
                    maxlength="16"
                    placeholder="XXXX - XXXX - XXXX - XXXX"
                    autoComplete="off"
                    value={cardNumber}
                    onChange={formatAndSetCcNumber}
                    onKeyDown={handleCardNumberKeyDown}
                  />
                  {errors.cardNumber === true && (
                    <span className="text-danger fz14">
                      Required
                    </span>
                  )}
                  {!errors.cardNumber &&
                    errors.invalid_card_number === true && (
                      <span className="text-danger fz14">
                        Please enter upto 16 digits
                      </span>
                    )}
                </div>
              </div>
              <div className="col-6 mb-4">
                <div className="input-grbox">
                  <label className="blackC">
                    Expiration Date<sup>*</sup>
                  </label>
                  <input
                    type="tel"
                    className="fillinput"
                    placeholder="MM/YYYY"
                    autoComplete="off"
                    pattern="^(0[1-9]|1[0-2])\/?([0-9]{4})$"
                    value={expiryDate}
                    onChange={(e) => {
                      errors.expiryDate = false;
                      const finalValue = replaceValue(e.target.value);
                      const re =
                        /^[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\d]*$/g;
                      if (e.target.value.match(re)) {
                        setExpiryDate(finalValue);
                      }
                    }}
                  />
                  {errors.expiryDate === true && (
                    <span className="text-danger fz14">
                      Required
                    </span>
                  )}
                </div>
              </div>
              <div className="col-6 mb-4">
                <div className="input-grbox">
                  <label className="blackC">
                    CVV<sup>*</sup>
                  </label>
                  <input
                    type="number"
                    className="fillinput"
                    placeholder="****"
                    value={cvv}
                    onKeyDown={handleCardNumberKeyDown}
                    onChange={(event) => {
                      const { value } = event?.target;
                      if (
                        allowNumbersWithNoSpaces(value) &&
                        value.length < 5
                      ) {
                        errors.cvv = false;
                        setCvv(event.target.value);
                      }
                    }}
                  />
                </div>
                {errors.cvv === true && (
                  <span className="text-danger fz14">
                    Required
                  </span>
                )}
              </div>
              <div className="col-6 mb-3">
                <div className="input-grbox">
                  <label className="blackC">
                    Zip Code<sup>*</sup>
                  </label>

                  <input
                    type="number"
                    className="fillinput"
                    placeholder="Enter code"
                    value={zipcode}
                    onKeyDown={handleCardNumberKeyDown}
                    onChange={(event) => {
                      const { value } = event?.target;
                      if (
                        allowNumbersWithNoSpaces(value) &&
                        value.length < 8
                      ) {
                        errors.zipcode = false;
                        setZipcode(event.target.value);
                      }
                    }}
                  />
                </div>

                {errors.zipcode === true && (
                  <span className="text-danger fz14">
                    Required
                  </span>
                )}
              </div>
              <p className="txt">
                *Our process is PCi complaint, as your credit card is
                protected and safely secured
              </p>
            </div>

            <div className="btnCont-mt">
              <button
                type="submit"
                className="cusbtn w-100 text-center"
              // disabled={!isValid()}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default AddCardModal;
